import { Link, Stack } from '@mui/material';
import { MHMTypography } from '../MHM/MHMTypography';
import { useTranslation } from '../../../contexts/TranslationContext';
import { MHMPasswordField } from '../MHM/MHMPasswordField';
import { useState } from 'react';
import { account_controller } from '../../../controllers/account_controller';
import { ConfirmSaveModal } from './ConfirmSaveModal';
import { MHMButton } from '../MHM/MHMButton';
import { usePasswordFields } from '../../../hooks/usePasswordFields';

export function PasswordSettings() {
  const { t } = useTranslation();
  const {
    curPassword,
    newPassword,
    newPasswordChanged,
    rePassword,
    rePasswordChanged,
    passwordValidationError,
    matchPasswordsError,
    isPasswordValid,
    handleCurPasswordChange,
    handleNewPasswordChange,
    handleRepeatPasswordChange,
    resetPasswordFields,
  } = usePasswordFields();
  const [isModalOpen, setIsModalOpen] = useState(false);

  function openModal() {
    setIsModalOpen(true);
  }

  function closeModal() {
    setIsModalOpen(false);
  }

  async function savePassword() {
    if (!isPasswordValid) {
      return;
    }

    closeModal();

    try {
      await account_controller.change_user_password(newPassword, curPassword);
      alert(t('Update Successful'));
      resetPasswordFields();
    } catch {
      alert(t('Password Incorrect'));
    }
  }

  return (
    <>
      <Stack gap={2} flex={1}>
        <MHMTypography variant="h6" color="primary">
          {t('Change Password')}
        </MHMTypography>

        <MHMPasswordField
          label={t('Old Password')}
          value={curPassword}
          fullWidth
          size="small"
          onChange={handleCurPasswordChange}
        />

        <MHMPasswordField
          label={t('New Password')}
          value={newPassword}
          fullWidth
          size="small"
          onChange={handleNewPasswordChange}
          error={Boolean(newPasswordChanged && passwordValidationError)}
          helperText={newPasswordChanged ? t(passwordValidationError) : null}
        />

        <MHMPasswordField
          label={t('Repeat New Password')}
          value={rePassword}
          fullWidth
          size="small"
          onChange={handleRepeatPasswordChange}
          error={Boolean(rePasswordChanged && matchPasswordsError)}
          helperText={rePasswordChanged ? t(matchPasswordsError) : null}
        />

        <MHMButton
          disabled={!isPasswordValid}
          onClick={openModal}
          sx={{ width: 'fit-content' }}
        >
          {t('Save')}
        </MHMButton>

        <Link
          color="primary"
          href="https://device-service.manhole-metrics.com/redirect-to-password-policy"
        >
          ({t('View our Password Policy')})
        </Link>
      </Stack>

      <ConfirmSaveModal
        open={isModalOpen}
        onCancel={closeModal}
        onConfirm={savePassword}
        message={t('Are you sure your new account information is correct?')}
      />
    </>
  );
}
